const inventoryService = async (items, inventoryApiConfig, signal, cookieContext) => {
  const { warehouse } = cookieContext;
  const { distributionCenters, nearestWarehouse, groceryCenters } = warehouse;
  const { apiUrl, env, clientId } = inventoryApiConfig || {};
  if (!apiUrl || !clientId || !env || !items) return;
  const body = {
    distributionCenters: [...distributionCenters, ...groceryCenters],
    itemNumbers: items,
    selectedWarehouse: nearestWarehouse == null ? void 0 : nearestWarehouse.catalog
  };
  const options = {
    body: JSON.stringify(body),
    headers: {
      "client-identifier": clientId,
      "content-type": "application/json",
      "costco.env": env,
      "costco.service": "restInventory"
    },
    method: "POST",
    signal
  };
  try {
    const response = await fetch(apiUrl, options);
    return response;
  } catch (err) {
    if (err instanceof Error && err.name === "AbortError") {
      console.info("Inventory Fetch Aborted");
    } else {
      console.error("Inventory Fetch Failed");
    }
  }
};
export {
  inventoryService
};
